import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';

import { UserService } from '@services/http/user.service';

import { TranslatePipe } from '@app/pipes/translate.pipe';

@Component({
  selector: 'app-reset-password',
  templateUrl: './resetPassword.component.html',
  styleUrls: ['./resetPassword.component.scss'],
})
export class ResetPasswordComponent {
  password: string;
  confirmPassword: string;
  inputFocusClass: number;
  characterLenghtColor = 'red';
  lowerCharacterColor = 'red';
  upperCharacterColor = 'red';
  lastNameLenghtColor = 'red';
  firstNameLenghtColor = 'red';
  numberColor = 'red';
  lastNameNumberColor = 'red';
  firstNameNumberColor = 'red';
  characterLenghtColorCheck = false;
  lowerCharacterColorCheck = false;
  upperCharacterColorCheck = false;
  firstPasswordIsTouched = false;
  numberColorCheck = false;

  constructor(
    private toastr: ToastrService,
    private router: Router,
    private route: ActivatedRoute,
    private translatePipe: TranslatePipe,
    private userService: UserService,
  ) {
    this.password = '';
    this.confirmPassword = '';
    this.inputFocusClass = 0;

    this.checkToken();
  }


  public passwordHasBeenTouchedFunc() {
    this.firstPasswordIsTouched = true;
  }

  checkToken() {
    this.route.queryParams.subscribe((params) => {
      if (!params.token) {
        return this.router.navigate(['/login']);
      }
    });
  }

  isBtnDisabled(): boolean {
    if (!this.password || this.password.trim().length === 0) {
      return true;
    }
    if (!this.confirmPassword || this.confirmPassword.trim().length === 0) {
      return true;
    }
    return this.password !== this.confirmPassword;
  }

  private setAllColors(color: string) {
    this.characterLenghtColor = color;
    this.upperCharacterColor = color;
    this.lowerCharacterColor = color;
    this.numberColor = color;
  }

  private setAllChecks(value: boolean) {
    this.characterLenghtColorCheck = value;
    this.upperCharacterColorCheck = value;
    this.lowerCharacterColorCheck = value;
    this.numberColorCheck = value;
  }


  public setPasswordColor() {
    if (!this.password) {
      this.setAllColors('red');
      this.setAllChecks(false);
      return;
    }

    this.characterLenghtColor =
      this.password.trim().length >= 6 ? 'green' : 'red';

    let upper = false;
    let lower = false;
    let number = false;

    for (const char of this.password) {
      if (/[a-z]/.test(char)) {
        lower = true;
      } else if (/[A-Z]/.test(char)) {
        upper = true;
      } else if (/[0-9]/.test(char)) {
        number = true;
      }
    }

    this.upperCharacterColor = upper ? 'green' : 'red';
    this.lowerCharacterColor = lower ? 'green' : 'red';
    this.numberColor = number ? 'green' : 'red';

    this.characterLenghtColorCheck = this.characterLenghtColor === 'green';
    this.upperCharacterColorCheck = this.upperCharacterColor === 'green';
    this.lowerCharacterColorCheck = this.lowerCharacterColor === 'green';
    this.numberColorCheck = this.numberColor === 'green';
  }

  throwError() {
    // Check if password is empty
    if (!this.password || this.password.trim().length === 0) {
      this.toastr.error(
        this.translatePipe.transform('TOAST_MESSAGES.WARNING.PASS_EMPTY'),
      );
      return;
    }

    // Check if password and confirm password do not match
    if (this.password !== this.confirmPassword) {
      this.toastr.error(
        this.translatePipe.transform('TOAST_MESSAGES.WARNING.PASS_NOT_MATCH'),
      );
      return;
    }

    // Check if password does not meet the length requirement
    if (this.password.trim().length < 6) {
      this.toastr.error(
        this.translatePipe.transform('TOAST_MESSAGES.WARNING.PASS_SHORT'),
      );
      return;
    }

    // Check if password does not contain uppercase, lowercase, and number
    let upper = false;
    let lower = false;
    let number = false;

    for (const char of this.password) {
      if (/[a-z]/.test(char)) {
        lower = true;
      } else if (/[A-Z]/.test(char)) {
        upper = true;
      } else if (/[0-9]/.test(char)) {
        number = true;
      }
    }

    if (!upper || !lower || !number) {
      this.toastr.error(
        this.translatePipe.transform('TOAST_MESSAGES.WARNING.PASS_INVALID'),
      );
      return;
    }
  }



  reset() {
    if (this.isBtnDisabled()) {
      this.throwError();
      return;
    }
    this.userService
      .resetPassword({ newPassword: this.password })
      .subscribe(() => {
        this.router.navigate(['/login']);
        this.toastr.success(
          this.translatePipe.transform('TOAST_MESSAGES.SUCCESS.PASS_RESET'),
        );
      }, error => {
        // Handle error from the server
        this.throwError();
      });
  }
}
